import { List, Map } from "immutable";

import { Submit } from "../../components/form/index";
import qcache from "../../core/cache/queries";
import { Header, Request, Response } from "../../core/comm";
import comm from "../../core/comm/actions";
import form from "../../core/components/form/actions";
import storage from "../../core/storage/actions";
import { processCombo } from "../../core/util";

const urls = {
  get: {
    resendInvite: "/v1/organizacoes/:org/formandos/:student/reenvio_convites",
    orderChangePassWord: "/v1/organizacoes/:org/formandos/:student/password",
    accessData: "/v1/organizacoes/:org/formandos/:student/acesso_info",
    studentByEmail: "/v1/organizacoes/:org/usuario_por_email/:email",
    studentByCpf: "/v1/organizacoes/:org/usuario_por_cpf/:cpf",
    associationStatus: "/v1/usuarios_organizacoes_status",
    confirmRegister: "/v1/pub/confirmacao_cadastro/:cid",
    plans: "/v1/organizacoes/:org/planos_arrecadacao",
    cancelNewEmail: "/v1/all/cancelar_novo_email",
    students: "/v1/organizacoes/:org/formandos",
    address: "/v1/pub/enderecos/:cep",
    profile: "/v1/all/perfil",

    // Rotas de Observações
    observation: "v1/vendas/formaturas/formandos/observacoes",
    tiposVisibilidade: "v1/vendas/formaturas/formandos/observacoes/tipos_visibilidade",
    // anexos: "v1/vendas/formaturas/:codOrg/formandos/:codForm/observacoes/:codObs/anexos/:codArq",
  },
  put: {
    linkStudent: "/v1/organizacoes/:org/formandos_formatura/:student",
    confirmRegister: "/v1/pub/confirmacao_cadastro/:cid",
    student: "/v1/organizacoes/:org/formandos/:student",

    editObservation: "v1/vendas/formaturas/:codOrg/formandos/:codForm/observacoes/:codObs",
  },
  post: {
    student: "/v1/organizacoes/:org/formandos",
    reactivateStudent: "/v1/organizacoes/:org/formandos/:student/reativacao",
    linkStudent: "/v1/organizacoes/:org/formandos_formatura/:student",
    profile: "/v1/all/perfil",
    renunciation: "/v1/organizacoes/:org/formandos/:student/desistencia",
    studentChangeEmail: "/v1/organizacoes/:org/formandos/:student/email",
    profileChangeEmail: "/v1/all/perfil_email",
    group: "/v1/organizacoes/:org/turmas",
    saveAvatar: "/v1/all/avatar",

    addObservation: "v1/vendas/formaturas/:codOrg/formandos/:codForm/observacoes",
    addAnexos: "v1/vendas/formaturas/:codOrg/formandos/:codForm/observacoes/:codObs/anexos",
  },
  del: {
    student: "/v1/organizacoes/:org/formandos/:student",

    deleteObservation: "v1/vendas/formaturas/:codOrg/formandos/:codForm/observacoes/:codObs",
  },
  download: {
    anexosObs: "v1/vendas/formaturas/:codOrg/formandos/:codForm/observacoes/:codObs/anexos/:codArq",
  },
  combos: {
    profilesStudentsType: "/v1/perfis_formando",
    groups: "/v1/organizacoes/:org/turmas",
    phoneTypes: "/v1/pub/telefone_tipos",
    profiles: "/v1/fmt/perfis",
    gender: "/v1/pub/sexos",
    shifts: "/v1/turnos",
  },
};

const applet = "/formandos";

const views = {
  create: `${applet}/cadastrar`,
  detail: `${applet}/:formando`,
  detailCerimonial: `/formaturas/:codGraduation/formandos/:formando`,
  list: `${applet}/listar`,
  observation: `${applet}/:formando`,
};

// /////////////////////////////////////////////////////////
//
// Util
//
// /////////////////////////////////////////////////////////

/**
 * Transforma um map de estudante em um objeto.
 * @param {Map} data
 */
function queryStudent(data) {
  return {
    nome: data.get("nome"),
    email: data.get("email"),
    codigo: data.get("codigo"),
    novoEmail: data.get("novoEmail"),
    codStatus: data.getIn(["status", "codigo"]),
    indBloqueado: data.get("indBloqueado"),
    codAssociacao: data.getIn(["associacao", "codigo"]),
    codTrocarEmail: data.get("codSolicitacaoTrocaEmail"),
    indEditarCPF: data.get("indEditarCPF"),
    indPodeAlterarPerfil: data.get("indPodeAlterarPerfil"),
    perfil: data.get("perfil"),
  };
}

/**
 * Envia uma variável booleana 'isOpen' para o storage.
 */
function setIsOpen(view, flag) {
  return storage.set(view, ["isOpen"], flag);
}

/**
 * Retorna dados de combos.
 */
function getCombos(state, view) {
  return {
    groups: qcache.getData(state, view, urls.combos.groups),
    genders: qcache.getCombo(state, urls.combos.gender),
    phoneTypes: qcache.getCombo(state, urls.combos.phoneTypes),
    profileTypes: qcache.getCombo(state, urls.combos.profilesStudentsType),
    shifts: qcache.getCombo(state, urls.combos.shifts),
  };
}

// /////////////////////////////////////////////////////////
//
// Ações & Subscribes
//
// /////////////////////////////////////////////////////////

function setOpenGroupDrawer(view, value) {
  return storage.set(view, ["newClass"], value);
}

/**
 * Envia as informações de um formando para o storage.
 */
function setLoadedStudent(view, student) {
  return storage.set(view, ["loadedStudent"], student);
}

/**
 * Retorna os possíveis gêneros do banco de dados.
 */
function fetchGender() {
  return comm.getCombo(urls.combos.gender);
}

/**
 * Retorna os possíveis tipos de telefones.
 */
function fetchPhoneTypes() {
  return comm.getCombo(urls.combos.phoneTypes);
}

/**
 * Retorna os possíveis perfis para formandos.
 */
function fetchProfilesTypes() {
  return comm.getCombo(urls.combos.profilesStudentsType);
}

/**
 * Retorna os possíveis turnos para uma turma.
 */
function fetchShifts() {
  return comm.getCombo(urls.combos.shifts);
}

/**
 * Retorna os possíveis turmas.
 */
function fetchGroups(props, force = false) {
  const { currentOrganizationID, view } = props;
  return comm.get(
    Request({
      view,
      url: urls.combos.groups,
      urlParams: Map({ org: currentOrganizationID }),
      force,
      onSuccess: Response({
        transform: processCombo,
      }),
    }),
  );
}

/**
 * Limpa um formulário
 */
function cleanForm(view, formID = "form") {
  return form.clean(view, formID);
}

/**
 * Requisita a lista de formandos cadastrados na dada organização.
 */
function fetchStudents(props, force = false, filter = null) {
  const { currentOrganizationID } = props;
  return comm.get(
    Request({
      view: applet,
      url: urls.get.students,
      urlParams: Map({ org: currentOrganizationID }),
      force,
      header: Header({
        include: List(["status", "associacao", "telefones", "perfil", "plano", "contrato"]),
        sort: List(["nome"]),
        filter,
      }),
    }),
  );
}

/**
 * Retorna um `Record` do tipo `Submit` para criar uma nova turma.
 */
function setNewGroupInToForm(view, formID, data) {
  return form.setFieldState(view, formID, {
    field: "turma",
    value: data.first().get("codigo"),
  });
}

function submitNewGroup(view, currentOrganizationID, formID) {
  return Submit({
    method: "post",
    request: Request({
      url: urls.post.group,
      urlParams: Map({ org: currentOrganizationID }),
      onSuccess: Response({
        dispatch: List([
          () => fetchGroups({ view, currentOrganizationID }, true),
          (data) => setNewGroupInToForm(view, formID, data),
          () => setOpenGroupDrawer(view, false),
          () => cleanForm(view, "groupForm"),
        ]),
      }),
    }),
  });
}

/**
 * Retorna todos os dados necessários para as telas de perfil
 * e cadastro de formando.
 *
 * @param {object} data Dados retornados do banco.
 */
function transformUserData(data) {
  let student = data.first();
  if (!student) {
    return null;
  }
  // As ruas, as vezes, vem com mais informações separadas por '-'.
  const street = student.get("endereco") ? student.get("endereco").split(" - ")[0] : "";
  student = student.set("endereco", street);

  return student;
}

/**
 * Preenche o formulário com os dados passados.
 */
function mergeToForm(data, view, id = "form") {
  if (!data) {
    return data;
  }
  return form.merge(view, id, data);
}

/**
 * Retorna os dados somente da seção de endereço.
 */
function transformCepData(data) {
  const d = data.first();
  if (!d) {
    return Map();
  }

  const street = d.get("descricao");
  return Map({
    cidade: d.getIn(["cidade", "nome"]),
    estado: d.getIn(["estado", "nome"]),
    endereco: street ? street.split(" - ")[0] : "",
    bairro: d.getIn(["bairro", "descricao"]),
    cidadeCod: d.getIn(["cidade", "codigo"]),
    codLogradouro: d.get("codigo"),
  });
}

/**
 * Consulta no banco os dados de um endereço de acordo com o CEP.
 */
function fetchAddressByCep(cep, view, id) {
  return comm.get(
    Request({
      view,
      url: urls.get.address,
      urlParams: Map({ cep }),
      onSuccess: Response({
        transform: transformCepData,
        dispatch: List([(data) => mergeToForm(data, view, id)]),
      }),
      header: Header({
        include: List(["cidade", "estado", "bairro", "tipo"]),
      }),
    }),
  );
}

/**
 * Pega os dados do usuario com o email passado por parâmetro e
 * preenche o formulário com os mesmos.
 */
function fetchStudentByEmailWithMerge(view, email) {
  return comm.get(
    Request({
      view,
      url: urls.get.studentByEmail,
      urlParams: Map({ email }),
      onSuccess: Response({
        // dismiss: true,
        transform: transformUserData,
        dispatch: List([(data) => mergeToForm(data, view), (data) => setLoadedStudent(view, data)]),
      }),
    }),
  );
}

export {
  views,
  urls,
  applet,
  cleanForm,
  getCombos,
  setIsOpen,
  fetchShifts,
  fetchGender,
  fetchGroups,
  mergeToForm,
  queryStudent,
  fetchStudents,
  submitNewGroup,
  fetchPhoneTypes,
  setLoadedStudent,
  transformUserData,
  fetchAddressByCep,
  fetchProfilesTypes,
  setOpenGroupDrawer,
  fetchStudentByEmailWithMerge,
};
